import styled from 'styled-components'
import { FONT_SIZE, NATIVE_BASE_COLORS } from '../../../../themes'

const topBarHeight = 66
const pinCodeHeight = 52
const meetingInfoBoxPadding = 32
const bottomBarHeight = 84

const cateringItemBoxHeight = () => {
  return `calc(100vh - ${topBarHeight + pinCodeHeight + bottomBarHeight + (3 * meetingInfoBoxPadding)}px)`
}

export const CateringManagementStyle = styled.div`
  padding: 32px 40px 32px 24px;
  max-height: calc(100vh - ${topBarHeight + pinCodeHeight + (2 * meetingInfoBoxPadding) + bottomBarHeight}px);
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 0px;
  }

  .catering-management__title {
    padding: 0 0 16px 0;
    margin: 0;
    font-family: LibreBaskervilleBold;
    font-size: ${FONT_SIZE.LG2};
  }

  .catering-management__divider {
    height: 1px;
    width: 100%;
    background-color: ${NATIVE_BASE_COLORS.MUTED[200]};
  }

  .catering-management__item-box {
    display: ${props => props.haveItemList ? '' : 'flex'};
    justify-content: ${props => props.haveItemList ? '' : 'center'};
    align-items: ${props => props.haveItemList ? '' : 'center'};
    height: ${props => props.haveItemList ? '' : cateringItemBoxHeight()};
  }
`
